export const fileFormatMapper = (fileFormat: string): string => {
  switch (fileFormat) {
    case 'application/msword':
      return 'doc';
    case 'application/pdf':
      return 'pdf';
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      return 'docx';
    default:
      return fileFormat;
  }
};
